import { createContext, getContext, setContext } from "svelte";
import { type dataField } from "../../../lib/dataform/dataFormLib.svelte";

export type FieldContext = {
  field: ReturnType<typeof dataField>;
  required: boolean;
};

const [getFieldContext, setFieldContext] = createContext<FieldContext>()

export {getFieldContext, setFieldContext}
